import React from "react"
import PropTypes from "prop-types"
import ExpensesTreeAccordion from "./ExpensesTreeAccordion"

import { Box, Stack, Grid, Paper, Typography } from "@mui/material"

import Card from "@mui/material/Card"
import CardContent from "@mui/material/CardContent"
import ExpensesInput from "./ExpensesInput"

const ExpensesColumn = ({
  selectedItems = {},
  projectsData = [],
  allocation,
  setAllocation,
  expandedAccordions,
  setExpandedAccordions,
  organizationSelected,
  organizationAmount,
  setOrganizationAmount,
  projectId,
}) => {
  const hasAnySelected = projectsData.some(
    project =>
      Array.isArray(project.chapters) &&
      project.chapters.some(chapter =>
        hasAnySelectedInTree(chapter, selectedItems),
      ),
  )

  function collectChaptersWithPartidas(chapter, list) {
    if (Array.isArray(chapter.partidas) && chapter.partidas.length > 0) {
      list.push(chapter)
    }
    if (Array.isArray(chapter.chapters)) {
      chapter.chapters.forEach(sub => collectChaptersWithPartidas(sub, list))
    }
  }

  function getChaptersWithPartidasInProject(project) {
    const list = []
    if (Array.isArray(project.chapters)) {
      project.chapters.forEach(ch => collectChaptersWithPartidas(ch, list))
    }
    return list
  }

  return (
    <Grid item xs={12} md={5}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          mb: 1,
          mt: 2,
        }}
      >
        <Typography
          sx={{
            fontWeight: "medium",
            flexShrink: 0,
            mt: 2,
          }}
        >
          Gastos
        </Typography>
      </Box>

      <Paper
        variant="outlined"
        sx={{
          p: 2,
          height: "463px",
          borderRadius: 2,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        {/* Organization card with numeric input */}
        {organizationSelected && !projectId && (
          <Card
            sx={{
              mb: 2,
              backgroundColor: "grey.300",
              boxShadow: "none",
              border: "1px solid",
              borderColor: "divider",
            }}
          >
            <CardContent sx={{ px: 2, display: "flex", alignItems: "center" }}>
              <Typography sx={{ fontWeight: "bold", mr: 2 }}>
                Organización
              </Typography>
              <Box sx={{ minWidth: 100 }}>
                <ExpensesInput
                  value={organizationAmount}
                  onChange={v => setOrganizationAmount(v.floatValue || 0)}
                  size="medium"
                />
              </Box>
            </CardContent>
          </Card>
        )}
        <Box sx={{ flex: 1, overflowY: "auto" }}>
          {!hasAnySelected && !organizationSelected && (
            <Stack
              direction="column"
              sx={{
                p: 2,
                height: "100%",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                textWrap: "balance",
              }}
            >
              <Typography variant="body2" color="text.secondary">
                Selecciona en donde imputar el gasto
              </Typography>
            </Stack>
          )}
          {projectsData
            .filter(project => !projectId || project.projectId === projectId)
            .filter(project => {
              if (!Array.isArray(project.chapters)) return false
              return project.chapters.some(ch =>
                hasAnySelectedInTree(ch, selectedItems),
              )
            })
            .map(project => {
              const chaptersToShow = getChaptersWithPartidasInProject(project)
              return (
                <React.Fragment key={project.projectId}>
                  {!projectId && (
                    <Typography
                      variant="subtitle2"
                      sx={{
                        fontWeight: "bold",
                        mb: 0.5,
                        mt: 1,
                        color: "text.secondary",
                      }}
                    >
                      {project.name}
                    </Typography>
                  )}
                  {chaptersToShow.map(chapter => (
                    <ExpensesTreeAccordion
                      key={chapter.chapterId}
                      chapter={chapter}
                      selectedItems={selectedItems}
                      allocation={allocation}
                      setAllocation={setAllocation}
                      expandedAccordions={expandedAccordions}
                      setExpandedAccordions={setExpandedAccordions}
                    />
                  ))}
                </React.Fragment>
              )
            })}
        </Box>
      </Paper>
    </Grid>
  )
}

function hasAnySelectedInTree(chapter, selectedItems) {
  if (selectedItems[chapter.chapterId]) return true
  if (
    Array.isArray(chapter.chapters) &&
    chapter.chapters.some(sub => hasAnySelectedInTree(sub, selectedItems))
  )
    return true
  if (
    Array.isArray(chapter.partidas) &&
    chapter.partidas.some(partida => {
      if (selectedItems[partida.partidaId]) return true
      if (Array.isArray(partida.decompositions)) {
        return partida.decompositions.some(
          (_, idx) => selectedItems[`${partida.partidaId}_${idx}`],
        )
      }
      return false
    })
  )
    return true
  return false
}

ExpensesColumn.propTypes = {
  selectedItems: PropTypes.object,
  projectsData: PropTypes.array,
  allocation: PropTypes.object.isRequired,
  setAllocation: PropTypes.func.isRequired,
  expandedAccordions: PropTypes.object,
  setExpandedAccordions: PropTypes.func,
  organizationSelected: PropTypes.bool,
  organizationAmount: PropTypes.number,
  setOrganizationAmount: PropTypes.func,
  projectId: PropTypes.string,
}

export default ExpensesColumn
